import { Component, OnInit } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { ActivatedRoute, Router } from "@angular/router";
import {
  faLinkedinIn,
  faTwitter,
  faInstagram,
  faFacebookF,
} from "@fortawesome/free-brands-svg-icons";
import { Meta } from "@angular/platform-browser";
import { environment } from "src/environments/environment";
import { VagasService } from "src/app/services/vagas.service";

@Component({
  selector: "app-vagas",
  templateUrl: "./vagas.component.html",
  styleUrls: ["../../fisico.component.css"],
})
export class VagasComponent implements OnInit {
  linkedin = faLinkedinIn;
  facebook = faFacebookF;
  twitter = faTwitter;
  instagram = faInstagram;

  loading = true;
  vagas = [];
  vagasFiltr = [];
  vagasFiltro = [];
  empresas = [];
  empresasFiltradas = [];
  filtro;
  palavra;
  empresasFilt = false;
  empresaId;
  regiaoFilt = false;
  regiaoVal;
  cidadeVal;
  cidadeFilt = false;
  vagasFilt = false;
  regioes = [];
  regioesFiltradas = [];
  cidadesFiltradas: any[] = [];
  load = true;
  selectEmp = "p";
  selectEstado = "p";
  selectCidade = "p";
  inputTituloVaga = "";

  buscar = false;
  busca;
  lista = false;
  tituloVal: string;
  tituloFilt: boolean;

  constructor(
    private http: HttpClient,
    private route: ActivatedRoute,
    private router: Router,
    private meta: Meta,
    private service: VagasService
  ) {
    this.getVagas();
    // this.meta.updateTag(
    //   { name: 'title', content: 'Reachr - Vagas'
    // });
    // this.meta.updateTag(
    //   { name: 'description', content: 'Filtre sua busca, selecione uma empresa, selecione uma região, vagas parceiros'
    // });
    // this.meta.updateTag(
    //   { name: 'keywords', content: 'selecione uma empresa,selecione uma região, vagas parceiros,aspectos profissionais,chances de sucesso,oportunidades de desenvolvimento,mercado de trabalho,Avalie as suas tendências em habilidades,habilidades como liderança, comunicação e capacidade de adaptação,vagas de emprego,oportunidade de trabalho,agencia de emprego,vagas,emprego,olx empregos,vaga de emprego,comunidade de emprego,'
    // });
  }

  list() {
    this.lista = true;
  }

  grid() {
    this.lista = false;
  }

  getVagas() {
    this.service.getVagas().subscribe((res) => {
      let vagas = res.Itens;
      this.processarEmFila(vagas, 200);
      // this.checarLogosESigiloEmpresa(vagas);
      this.ordenarEmpresas();
      this.filtrarArray();
      this.filtrarArrayEstados();
      this.filtrarArrayCidade(vagas);
      this.checarParametrosDeBusca();
      this.loading = false;
      this.load = false;
    });
  }

  dividirArrayEmLotes<T>(array: T[], tamanhoLote: number): T[][] {
    const lotes: T[][] = [];
    for (let i = 0; i < array?.length; i += tamanhoLote) {
      lotes.push(array.slice(i, i + tamanhoLote));
    }
    return lotes;
  }

  processarEmFila(vagas: any[], tamanhoLote: number) {
    const lotes = this.dividirArrayEmLotes(vagas, tamanhoLote);

    const processarLote = (loteIndex: number) => {
      if (loteIndex >= lotes.length) {
        this.loading = false; // Finaliza o carregamento
        return;
      }

      const lote = lotes[loteIndex];
      this.checarLogosESigiloEmpresa(lote); // Processa o lote
      console.log(`Lote ${loteIndex + 1}/${lotes.length} processado.`);

      if (loteIndex === 0) {
        // Marca o carregamento inicial como concluído para exibir as vagas do primeiro lote
        this.loading = false;
      }

      // Agenda o próximo lote para processar em segundo plano
      setTimeout(() => processarLote(loteIndex + 1), 100); // Intervalo ajustável
    };

    processarLote(0); // Inicia o processamento com o primeiro lote
  }

  checarParametrosDeBusca() {
    this.route.params.subscribe((params) => {
      const busca = params.busca;
      if (busca) {
        this.buscar = true;
        this.filtro = busca;
        setTimeout(() => {
          console.log("filtrando..");
          this.filtrar();
        }, 100);
      }
    });
  }

  ordenarEmpresas() {
    this.empresas.sort(function (a, b) {
      return a.Nome - b.Nome;
    });
  }

  onScroll(event: any) {
    const { scrollTop, scrollHeight, clientHeight } = event.target;
    console.log(event);
    // if (scrollHeight - scrollTop <= clientHeight + 100 && !this.loadingMore) {
    //   this.loadVagas();
    // }
  }

  checarLogosESigiloEmpresa(vagas: any) {
    for (let vaga of vagas) {
      if (vaga.Nome) {
        vaga.Logo = !vaga.SigiloNomeEmpresa
          ? vaga.Logo
          : "./assets/img/logotypes/confidencial.png";
        vaga.UrlVaga = vaga.UrlVaga.replace(
          "https://reachr.com.br",
          environment.serverUrl
        );

        this.vagas.push(vaga);
        if (!vaga.SigiloNomeEmpresa) {
          this.vagasFiltro.push(vaga);
          const empresa = {
            EmpresaId: vaga.EmpresaID,
            Nome: vaga.Empresa,
          };
          this.empresas.push(empresa);
          this.regioes.push({ estado: vaga.UF });
        }
      }
    }
  }

  // this.http.get(url, { headers: headers }).subscribe((data) => {
  //   console.log("finish");
  //   const res = JSON.parse(JSON.stringify(data));
  //   array = res.Itens;
  //   let i = 0;

  //   for (i; i < array.length; i++) {
  //     if (array[i].Nome) {
  //       array[i].Logo = !array[i].SigiloNomeEmpresa
  //         ? array[i].Logo
  //         : "./assets/img/logotypes/confidencial.png";
  //       array[i].UrlVaga = array[i].UrlVaga.replace(
  //         "https://reachr.com.br",
  //         environment.serverUrl
  //       );

  //       this.vagas.push(array[i]);
  //       if (!array[i].SigiloNomeEmpresa) {
  //         this.vagasFiltro.push(array[i]);
  //         const empresa = {
  //           EmpresaId: array[i].EmpresaID,
  //           Nome: array[i].Empresa,
  //         };
  //         this.empresas.push(empresa);
  //         this.regioes.push({ estado: array[i].UF });
  //       }
  //     }
  //     // console.log(array[i]);
  //     this.empresas.sort(function (a, b) {
  //       return a.Nome - b.Nome;
  //     });
  //   }

  //   this.loading = false;
  //   this.load = false;
  //   this.filtrarArray();
  //   this.filtrarArrayEstados();
  //   this.route.params.subscribe((params) => {
  //     const busca = params.busca;
  //     if (busca) {
  //       this.buscar = true;
  //       this.filtro = busca;
  //       setTimeout(() => {
  //         console.log("filtrando..");
  //         this.filtrar();
  //       }, 100);
  //     }
  //   });
  // });

  ngOnInit() {
    // const doc = document.getElementById('fale-conosco-modal');
    // doc.style.display = 'none'
  }

  filtrarEmp() {
    if (this.selectEmp !== "p") {
      this.empresaId = this.selectEmp;
      this.empresasFilt = false;
      this.vagasFilt = true;
      this.filtrarVagas();
    } else {
      this.empresaId = "p";
      this.filtrarVagas();
    }
  }

  filtrarEst() {
    if (this.selectEstado !== "p") {
      this.regiaoVal = this.selectEstado;
      this.regiaoFilt = false;
      this.vagasFilt = true;
      this.filtrarVagas();
    } else {
      this.regiaoVal = "p";
      this.filtrarVagas();
    }
  }

  filtrarTituloVaga(event: any) {
    console.log(event);
    console.log(this.inputTituloVaga);
    if (this.inputTituloVaga !== "") {
      this.tituloVal = this.inputTituloVaga;
      this.tituloFilt = false;
      this.vagasFilt = true;
      this.filtrarVagas();
    } else {
      this.tituloVal = "p";
      this.filtrarVagas();
    }
  }

  filtrarCidade() {
    if (this.selectCidade !== "p") {
      this.cidadeVal = this.selectCidade;
      this.cidadeFilt = false;
      this.vagasFilt = true;
      this.filtrarVagas();
    } else {
      this.cidadeVal = "p";
      this.filtrarVagas();
    }
  }

  filtrarVagas() {
    this.load = true;
    const termoTitulo = this.tituloVal?.toLowerCase() || "";
    this.vagas = this.vagasFiltro.filter((vaga) => {
      const matchesEmpresa =
        this.empresaId && this.empresaId !== "p"
          ? vaga.EmpresaID === this.empresaId
          : true;
      const matchesRegiao =
        this.regiaoVal && this.regiaoVal !== "p"
          ? vaga.UF === this.regiaoVal
          : true;
      const matchesCidade =
        this.cidadeVal && this.cidadeVal !== "p"
          ? vaga.Cidade === this.cidadeVal
          : true;
      const matchesTitulo = termoTitulo
        ? vaga.Nome?.toLowerCase().includes(termoTitulo)
        : true;

      return (
        vaga.Nome &&
        matchesEmpresa &&
        matchesRegiao &&
        matchesCidade &&
        matchesTitulo
      );
    });
    this.load = false;
  }

  filtrarArray() {
    let array = [];

    array = this.empresas.filter(
      (value, index, array) =>
        !array.filter(
          (v, i) => JSON.stringify(value) === JSON.stringify(v) && i < index
        ).length
    );
    this.empresasFiltradas = [];
    console.log(array);
    this.empresasFiltradas = array.sort((a, b) => {
      if (a.Nome < b.Nome) {
        return -1;
      }
      if (a.Nome > b.Nome) {
        return 1;
      }
      return 0;
    });
  }

  filtrarArrayCidade(vagas: any) {
    let cidades = new Set<string>();
    this.cidadesFiltradas = [];

    for (let vaga of vagas) {
      if (!cidades.has(vaga.Cidade)) {
        cidades.add(vaga.Cidade);
        this.cidadesFiltradas.push(vaga.Cidade);
      }
    }

    this.cidadesFiltradas.sort((a, b) => a.localeCompare(b)); // ordenação alfabética
    console.log(this.cidadesFiltradas);
  }

  filtrarArrayEstados() {
    let array = [];
    array = this.regioes.filter(
      (value, index, array) =>
        !array.filter(
          (v, i) => JSON.stringify(value) === JSON.stringify(v) && i < index
        ).length
    );
    this.regioesFiltradas = [];

    this.regioesFiltradas = array;
  }

  tirarAcentoFiltro() {
    const palavra = this.filtro;
    let palavraSemAcento = "";
    const caracterComAcento = "áàãâäéèêëíìîïóòõôöúùûüçÁÀÃÂÄÉÈÊËÍÌÎÏÓÒÕÖÔÚÙÛÜÇ";
    const caracterSemAcento = "aaaaaeeeeiiiiooooouuuucAAAAAEEEEIIIIOOOOOUUUUC";

    for (let i = 0; i < palavra.length; i++) {
      const char = palavra.substr(i, 1);
      const indexAcento = caracterComAcento.indexOf(char);
      if (indexAcento !== -1) {
        palavraSemAcento += caracterSemAcento.substr(indexAcento, 1);
      } else {
        palavraSemAcento += char;
      }
    }

    return palavraSemAcento.toLocaleLowerCase();
  }

  tirarAcento() {
    const palavra = this.palavra;
    let palavraSemAcento = "";
    const caracterComAcento = "áàãâäéèêëíìîïóòõôöúùûüçÁÀÃÂÄÉÈÊËÍÌÎÏÓÒÕÖÔÚÙÛÜÇ";
    const caracterSemAcento = "aaaaaeeeeiiiiooooouuuucAAAAAEEEEIIIIOOOOOUUUUC";

    for (let i = 0; i < palavra.length; i++) {
      const char = palavra.substr(i, 1);
      const indexAcento = caracterComAcento.indexOf(char);
      if (indexAcento !== -1) {
        palavraSemAcento += caracterSemAcento.substr(indexAcento, 1);
      } else {
        palavraSemAcento += char;
      }
    }

    return palavraSemAcento.toLocaleLowerCase();
  }

  filtrar() {
    if (this.filtro !== "") {
      this.filtrarNome();
      this.filtrarEmpresa();
    } else {
      this.vagas = this.vagasFiltro;
    }
  }

  filtrarNome() {
    let array = [];
    array = this.vagasFiltro.filter((el) => {
      this.palavra = el.Nome;
      const str = this.tirarAcento();
      const stri = this.tirarAcentoFiltro();
      return str.indexOf(stri) >= 0;
    });

    if (array.length > 0) {
      this.vagas = array;
    }
  }

  filtrarEmpresa() {
    let array = [];
    array = this.vagasFiltro.filter((el) => {
      this.palavra = el.Empresa;
      const str = this.tirarAcento();
      const stri = this.tirarAcentoFiltro();
      return str.indexOf(stri) >= 0;
    });

    if (array.length > 0) {
      this.vagas = array;
    }
  }

  abrirVaga(vaga) {
    this.router.navigate([vaga.UrlVaga]);
  }

  switchToParceiros() {
    this.router.navigate(["parceiros"]);
  }
}
